(function() {
    'use strict';

    /**
    * blocks.exception Module
    *
    * Description handle application exceptions
    */
    angular.module('blocks.exception', ['blocks.logger']);

})();
